export const STAFF_QUESTION_NAMES = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  SEX: "sex",
  BIRTHDAY: "age",
}

// Questionnaire prompt names
export const PT_QUESTION_NAMES = {

  SELF_CONCERN: "selfConcern",
  OTHER_CONCERN: "otherConcern",
  EDUCATION_LEVEL: "educationLevel",
  AGE: "age",
  HEIGHT: "height",
  WEIGHT: "weight",
  DIABETES: "diabetes",
  STROKE: "stroke",
  HELP: "help",
  ANTIDEPRESSANTS: "antidepressants",
  EFFORT: "daysEffort",
  RISK: "riskScore",
};

// Voice recording prompt names
export const RECORDING_NAMES = {
  VOICE_TREE: "treePictureRecording",
  VOICE_MEMORY: "recallMemoryRecording",
  VOICE_PBJ: "sandwichRecording",
  VOICE_COUNT: "countBackRecording",
};

// Symbol task prompt names
export const SYMBOL_TASK = "symbolMatchingTask";


const prefLang = sessionStorage.getItem("preferredLanguage");

console.log("prefLang = " + prefLang)
// Possible Answers to questionnaire
export const FEMALE = "Female";
export const MALE = "Male";
// export const YES = prefLang === "ES" ? "Sí" : "Yes";
// export const NO = prefLang === "ES" ? "No" :"No";
// export const UNSURE = prefLang === "ES" ? "No Seguro" :"Unsure";
// export const LT_ONE = prefLang === "ES" ? "Menos de 1 día" : "Less than 1 day";
// export const ONE_TWO = prefLang === "ES" ? "1 a 2 días" : "1 - 2 days";
// export const THREE_FOUR = prefLang === "ES" ? "3 a 4 días" : "3 - 4 days";
// export const FIVE_SEVEN = prefLang === "ES" ? "5 a 7 días" : "5 - 7 days";
// export const NOFORMALEDU = prefLang === "ES" ? "Sin educación formal" : "No formal education";
// export const PRIMARY = prefLang === "ES" ? "Educación Primaria" : "Primary / elementary education";
// export const GED = prefLang === "ES" ? "Educación Intermedia / Educación secundaria/ GED" : "Secondary education / GED";
// export const COLLEGE = prefLang === "ES" ? "*Some* Licenciatura" : "High school graduate / Some college / Associate’s degree";
// export const BACHELOR = prefLang === "ES" ? "Licenciatura" : "Bachelor's degree";
// export const GRDUATED = prefLang === "ES" ? "Maestría / Doctorado" : "Master's / Doctorate degree";

// Conversion constants
export const INCHES_TO_METERS = 0.0254;
export const KG_TO_POUNDS = 2.20462;
export const POUNDS_TO_KG = 0.45359237;

// Sign-in field names
export const PASS = "password";
export const EMAIL = "email";
export const CONFIRM = "confirm";
export const SECRET = "secret";

// Route page names
export const PATH_NAMES = {
  LANGUAGE: "/lang",
  WELCOME: "/welcome",
  STAFF: "/staff",
  QUESTIONNAIRE: "/questionnaire",
  TEST: "/test",
  FINISH: "/finish",
  ID: "/",
};
